<p-table [value]="items()" [rowHover]="true">
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="entityKey()" style="width: 8rem;">Codice <p-sortIcon [field]="entityKey()" /></th>
            <th pSortableColumn="shortDescription">Nome <p-sortIcon field="shortDescription" /></th>
            <th>Descrizione</th>
            <th pSortableColumn="etiquetteId" style="width: 8rem;" >Etichetta <p-sortIcon field="etiquetteId" /></th>

        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
        <tr (click)="onSelect.emit(item)" class="cursor-pointer">
            <td><b>{{item[entityKey()] | leftPad:4 }}</b></td>
            <td><b>{{item.shortDescription}}</b></td>
            <td class="max-w-xs truncate">{{item.description}}</td>
            <td class="whitespace-nowrap"><p-tag severity="info" [value]="item.etiquetteId | etiquetteDecoder:etiquetteApi()"></p-tag></td>

        </tr>
    </ng-template>
</p-table>